export default __webpack_public_path__ + "static/media/25.dc4f5df5.jpg";